// app/javascript/material_evaluations/totals.js

export function calculateTotals(materialsContainer) {
  let grandTotal = 0;

  // Loop through each material row
  materialsContainer.querySelectorAll(".material-row").forEach(row => {
    const qty = parseFloat(row.querySelector(".qty-input")?.value) || 0;
    const unitPrice = parseFloat(row.querySelector(".unit-price-input")?.value) || 0;
    const totalPrice = qty * unitPrice;

    const totalInput = row.querySelector(".total-price-input");
    if (totalInput) {
      // Use global helper for formatting
      totalInput.value = totalPrice.toFixed(2); // Display as a number with 2 decimal places
    }

    grandTotal += totalPrice;
  });

  // Update the footer span instead of creating a new element
  const footerSpan = document.getElementById("materialsSectionGrandTotal");
  if (footerSpan) {
    footerSpan.textContent = `Grand Total Price: ${numWithCommas(grandTotal)}`;
  }
}
